import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.payments.EditCounterpartyPaymentDetailsPopupContent', {
    titleEdit: 'Edit {contact} payment details',
    titleNew: 'Add {contact} payment details',
    save: 'Save',
    helpText: 'What are contact payment details?',
    learnMore: 'Learn more',
    inputPlaceholder: 'Enter...',
    selectPlaceholder: 'Select...',
    defaultCheckbox: 'Set as default',
    payeeBankCountry: 'Bank account country',
    payerBankCountry: 'Contact country',
    accountCurrency: 'Account currency',
    validationError:
        'Some of the information provided appears to be invalid or incomplete. Please review the form and ensure all details are entered correctly.',
    areYouSureToRemove: 'Are you sure you want to remove the payment details?',
    cancel: 'Cancel',
    submitRemove: 'Yes, remove',
    remove: 'Remove',
    confirmTitle: 'Are you sure you want to continue?',
    confirmDescription:
        'Paying this person or business may lead to your money being sent to the wrong account. We may not be able to recover the money for you.',
    confirmButtonMessage: 'Confirm',
});
